export function createQuery(pathObj) {
  let path = "";
  if (pathObj) {
    Object.keys(pathObj).map((data, index) => {
      if (index == 0) {
        path = `/marketplace?${data}=${pathObj[data][0]}`;
      } else {
        path = path + `&${data}=${pathObj[data][0]}`;
      }
    });
  }
  return path;
}
